// extracted by mini-css-extract-plugin
export default {"mobileMaxWidth":"767px","mobilePanelHeight":"50%","mobileNavbarHeight":"55px"};